import React, {useState} from "react";
import ComicZone from "../img/ComicZone2023.png";
import Automoblox from "../img/Automoblox2023.png";
import CanadianHop from "../img/HopHouse2023.png";
import ProjectFinal from "../pdf/JasonWilliamsProject2.pdf";

/* An array of projects */
const projects = [
    {
        title: 'Comic Zone',
        description: 'Learning to use Bootstrap 5.3. Here I wanted to create a design and layout based on a comic book store.',
        image: ComicZone,
        link: 'https://monsieurjaws.github.io/Comic-Zone-2023/',
    },
    {
        title: 'Automoblox',
        description: 'Final Project of the Advanced Interface Design CSS class. Here I applied everything I learned throughout the course and utilized Bootstrap 5.3 to create a modern layout of the Automoblox website.',
        image: Automoblox,
        link: 'https://monsieurjaws.github.io/Automoblox2023/index.html',
    },
    {
        title: 'Canadian Hop House',
        description: 'A project in which where I applied the skills I learned in Adobe Illustrator and Photoshop with digital marketing to create a website mockup with a social media post for a fictional local Canadian Hop House.',
        image: CanadianHop,
        link: ProjectFinal,
    }
    // Add more projects here as needed
];

function Projects() {
    // State to track the current project index
    const [currentIndex, setCurrentIndex] = useState(0);
    // State to trigger reanimation 
    const [animationKey, setAnimationKey] = useState(0);    

    // Function to go to the next project
    const goToNext = () => {
        // Loop back to the first project
        setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
        // Trigger reanimation 
        setAnimationKey(prevKey => prevKey + 1);   
    };

    // Function to go to the previous project
    const goToPrevious = () => {
        // Loop back to the last project
        setCurrentIndex((prevIndex) => (prevIndex - 1 + projects.length) % projects.length);
        // Trigger reanimation 
        setAnimationKey(prevKey => prevKey + 1);   
    };

    const currentProject = projects[currentIndex];

    return (
        <section className="projects">
            <h1 className="animate__animated animate__slideInDown">
                Pr<span className="underline">ojects</span>
            </h1>
            <figure>
                <img
                    className="img-fluid mx-auto d-block animate__animated animate__fadeIn animate__delay-1s"
                    src={currentProject.image}
                    width="50%"
                    alt={currentProject.title}
                    // Use unique key by combining currentIndex and animationKey in order for the image animation to repeat
                    key={`image-${currentIndex}-${animationKey}`} 
                />
                 <figcaption
                    className={`mx-auto animate__animated animate__fadeIn animate__delay-2s`}
                    // Use unique key by combining currentIndex and animationKey in order for the text animation to repeat
                    key={`caption-${currentIndex}-${animationKey}`}
                >
                    {currentProject.description}
                    <a href={currentProject.link} id="skills-link"> View Project</a>
                    {/* Carousel controls */}
                    <div className="carousel-controls">
                        <button onClick={goToPrevious}>Previous</button>
                        <button onClick={goToNext}>Next</button>
                    </div>
                </figcaption>
            </figure>
            
        </section>
    );
};

export default Projects;